/* eslint-disable */
export default {
  all: 'Alle',
  company: 'Unternehmen',
  personal: 'Persönlich',
} as const;

// @key: @#@"all"@#@ @source: @#@"All"@#@
// @key: @#@"company"@#@ @source: @#@"Company"@#@
// @key: @#@"personal"@#@ @source: @#@"Personal"@#@
